module.exports = __webpack_public_path__ + "img/img21.035e1854.svg";